<template>
  <v-dialog v-model="dialogState" max-width="400" persistent>
    <v-card class="mx-auto" tile>
      <v-toolbar
        color="primary"
        flat
        dense
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pl-1">
        <v-container fluid>
          <v-row>
            <v-col cols="12">{{ message }}</v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="px-3 pb-3">
        <v-spacer></v-spacer>
        <v-btn small :color="btnOkColor" @click="handleOk">{{ btnOkMessage }}</v-btn>
        <v-btn small :color="btnCancelColor" @click="handleCancel">{{ btnCancelMessage }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Bevestigen',
    },
    titleColor: {
      type: String,
      default: 'primary',
    },
    message: {
      type: String,
      default: 'Weet je het zeker?',
    },
    btnOkMessage: {
      type: String,
      default: 'OK',
    },
    btnCancelMessage: {
      type: String,
      default: 'Annuleren',
    },
    btnOkColor: {
      type: String,
      default: 'primary',
    },
    btnCancelColor: {
      type: String,
      default: 'secondary',
    },
  },
  data: () => ({
    dialogState: false,
    params: null,
  }),
  methods: {
    showDialog(params = null) {
      if (params !== null) {
        this.params = params
      }
      this.dialogState = true
    },
    hideDialog() {
      this.dialogState = false
    },
    handleOk() {
      this.$emit('confirm', this.params)
      this.hideDialog()
    },
    handleCancel() {
      this.$emit('cancel', this.params)
      this.hideDialog()
    },
  }
}
</script>
